import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

class RowItem extends Component {
  _onClick = () => {
    const { task, openRightPanel } = this.props;

    openRightPanel(task);
  }

  render() {
    const { task } = this.props;

    return (
      <tr onClick={this._onClick} style={{ cursor: 'pointer' }}>
        <td>{task.get('name')}</td>
      </tr>
    )
  }
}

RowItem.propTypes = {
  task: PropTypes.instanceOf(Map),
  openRightPanel: PropTypes.func,
};

export default RowItem;



// WEBPACK FOOTER //
// ./src/views/Project/TaskDoctor/RowItem.js